import MobileHome from './MobileHome';

export default MobileHome;
